import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import AuthGuard from '../components/AuthGuard';
import { api } from '../lib/api';

interface StepData {
  index: number;
  expected_at: string | null;
  actual_at: string | null;
  done: boolean;
}

const stepMeta = [
  { num: '01', label: '已审核', icon: '/images/flow_yi.png', desc1: '提交资料已通过审核', desc2: '进入制卡流程', status: '赔付卡激活完成' },
  { num: '02', label: '已制卡', icon: '/images/flow_er.png', desc1: '卡片已制作完成', desc2: '进入发货准备', status: '制卡成功' },
  { num: '03', label: '已发货', icon: '/images/flow_sna.png', desc1: '卡片已通过加密渠道发出', desc2: '请注意查收物流信息', status: '保密发货' },
  { num: '04', label: '已签收', icon: '/images/flow_si.png', desc1: '您已成功签收', desc2: '感谢您的信任与支持', status: '等待收货' },
];

function formatDate(d: string | null) {
  if (!d) return '';
  try {
    const dt = new Date(d.includes('T') ? d : d.replace(' ', 'T'));
    if (isNaN(dt.getTime())) return d;
    const y = dt.getFullYear();
    const m = String(dt.getMonth() + 1).padStart(2, '0');
    const day = String(dt.getDate()).padStart(2, '0');
    const h = String(dt.getHours()).padStart(2, '0');
    const min = String(dt.getMinutes()).padStart(2, '0');
    const s = String(dt.getSeconds()).padStart(2, '0');
    return `${y}年${m}月${day}日\n${h}:${min}:${s}`;
  } catch { return d; }
}

export default function CardProgress() {
  const navigate = useNavigate();
  const [steps, setSteps] = useState<StepData[]>([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get('/cards/status').then(({ data }) => {
      if (!data.applied && !data.has_applied) {
        navigate('/cards', { replace: true });
        return;
      }
      setSteps(Array.isArray(data.steps) ? data.steps : []);
    }).catch(() => {}).finally(() => setLoading(false));
  }, [navigate]);

  return (
    <div className="max-w-md mx-auto min-h-screen bg-[url(/images/flow_beijing.png)] bg-[length:100%_100%] bg-no-repeat pb-[150px]" style={{ backgroundColor: '#8b0000' }}>
      <AuthGuard />

      {/* Back button */}
      <div className="pt-4 px-4">
        <button onClick={() => navigate(-1)} className="w-8 h-8 flex items-center justify-center rounded-full bg-black/20 text-white">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round"><path d="M15 18l-6-6 6-6" /></svg>
        </button>
      </div>
 
      {/* Steps */}
      <div className="px-4 pt-[180px]">
        {loading ? (
          <div className="text-center text-white/60 text-sm py-12">加载中...</div>
        ) : (
          <div className="space-y-0 mx-4">
            {stepMeta.map((meta, i) => {
              const step = steps[i];
              const done = step?.done ?? false;
              const dateStr = done ? (step?.actual_at || '') : '';

              return (
                <div key={i}>
                  {/* Step card */}
                  <div className={`${!done && i > 0 ? 'opacity-70' : ''}`}>
                    {/* Step header ribbon */}
                    <div className="flex items-start gap-3 bg-[length:100%_100%] bg-no-repeat h-[100px] relative" style={{ backgroundImage: `url(${meta.icon})` }}> 
                      {/* Right side: icon + status + date */}
                      <div className="absolute right-[37px] top-[45px] flex flex-col items-center gap-1 flex-shrink-0">  
                        {dateStr && (
                          <span className="text-[#999] text-[10px] text-left whitespace-pre-line">{formatDate(dateStr)}</span>
                        )}
                      </div>
                    </div>
                  </div>

                  {/* Connector arrow between steps */}
                  {i < 3 && (
                    <div className="flex justify-center py-1">
                      <div className="flex flex-col items-center">
                        <img src="/images/flow_dui.png" alt="" className="w-6 h-6" />
                      </div>
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        )}
      </div> 
    </div>
  );
}
